import getters from './getters'
import mutations from './mutations'
import actions from './actions'
// import socket from '@/plugins/socket.io';
//
// Vue.use(socket);
//
// import VueSocketIOExt from 'vue-socket.io-extended';
// import io from 'socket.io-client';
// import store from '@/store'
//
// const socket = io('http://team-chat.loc:8085', {
//   query: {
//     token: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC90ZWFtLWNoYXQubG9jOjgwODVcL2F1dGhcL2xvZ2luIiwiaWF0IjoxNTgwNzU0MjkzLCJleHAiOjE1ODU5MzgyOTMsIm5iZiI6MTU4MDc1NDI5MywianRpIjoiSkdsdURDdFZxVkJKc0tlTiIsInN1YiI6MSwicHJ2IjoiMjNiZDVjODk0OWY2MDBhZGIzOWU3MDFjNDAwODcyZGI3YTU5NzZmNyJ9.q3tv6ZtmzYzyEx_FzYzb1cRcP5sMDsmKKEQqjK1QWds'
//   }
// });
//
// Vue.use(VueSocketIOExt, socket, { store });

export default {
  state: {
    provider: {
      crm: {
        token: null,
        name: 'crm',
      },
      chat: {
        token: null,
        url: 'http://chat.pilki.com',
        port: '80',
      },
    },
    offset: 0,
    quantityUsers: 30,
    chatList: [],
    profile: {},
    users: [],
    members: [],
    imagesGallery: [],
    lastChatPage: null,
    // idChatActive: null,
    activeChat: {
      id: null,
      name: '',
      icon: '',
      type: 'private',
      create: null,
      endMessageTime: null,
      membersCount: null,
      messages: [],

      authorId: '',
      closedAt: '',
      createdAt: '',
      deletedAt: '',
      deletedBy: '',
      lastMessage: '',
      updatedAt: '',
      usersCount: '',
    },
    activeAnswerItem: {},
    selectedMessages: [],
    chatIdForForward: null,
    choiceForwardIsActive: false,
    forwardReadyMessages: [],
    editMessage: {},
    previous: {
      id: null,
      type: '', // chat || users
    },
  },
  getters: getters,
  mutations: mutations,
  actions: actions,
}
